"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;
var theme = {
  colors: {
    grey: "#D9D9D9",
    grey_secondary: "#595959",
    grey_tertiary: "#8C8C8C",
    grey_stone: "#BFBFBF",
    grey_fossil: "#dfdfdf",
    grey_faint: "#FAFAFA",
    light_grey: "#F5F5F5",
    black_primay: "#292929",
    black_secondary: "#262626",
    anchor_blue: "#3E6BBE",
    white: "#FFFFFF",
    transparent: "transparent",
    royal_blue: "#6589cb",
    blue_primay: "#17365D",
    blue_secondary: "#005DAB",
    pie_yellow: "#FFD051",
    pie_green: "#4BB370",
    pie_aquablue: "#67AFE0",
    pie_orange: "#F49B48",
    pie_red: "#E97162",
    pie_taupe: "#C7B8A4",
    light_blue: "#E2E8F4",
    peel_orange: "#F6AF6D",
    black_tertiary: "#2F2E2F",
    green: "#2AA81D",
    dark_blue: "#455E7D",
    danger_red: "#ba5a4e",
    green_tertiary: "#3C8F5A",
    blue_tertiary: "#325698",
    grey_dark: "#88898c",
    orange_primary: "#ff5a23",
    black_sorted: "#2d2e31",
    green_light: "#F3F6FB",
    clean_black: "#000000",
    pearl_river: "#F0F0F0",
    copper_yellow: "#F49B48",
    navy_blue: "#254072",
    bar_purple: "#B380EB",
    bar_pink: "#FA85C0"
  },
  font_size: {
    size_3xl: "24px",
    size_2xl: "20px",
    size_xl: "16px",
    size_l: "14px",
    size_m: "12px",
    size_s: "8px"
  },
  font_wt: {
    medium: "Inter Medium",
    semibold: "Inter Semibold",
    bold: "Inter Bold"
  },
  icon_size: {
    icon_2xl: "21px"
  },
  shadows: {
    dropdown: "0px 3px 6px -4px rgba(0, 0, 0, 0.12)",
    sidebar: "rgba(38, 38, 38, 0.1)",
    button_focus: "0 0 0 0.2rem rgb(23 54 93 / 50%)",
    tooltip: "0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 3px 6px -4px rgba(0, 0, 0, 0.12)",
    input_focus: "0px 0px 0px 2px rgba(23, 54, 93, 0.2)",
    modal: "0px 36px 56px -4px rgba(0, 0, 0, 0.12)"
  },
  rgba: {
    menuactive: "rgba(23, 54, 93, 0.1)",
    menuactive_tretiary: "rgba(23, 54, 93, 0.2)",
    hover: "rgba(226, 232, 244, 0.6)",
    gradient_blue: "rgba(23, 54, 93, 0.07)",
    row_hover: "rgba(62, 107, 190, 7%)",
    modal: "rgba(23, 54, 93, 0.35)"
  }
};
exports.theme = theme;